<template>
    <b-tabs v-model="tabIndex" card>
        <b-tab title="Claim Uploads">
            <div class="row border-bottom">
                <div class="col-12">
                    <div class="mb-2 float-right">
                        <div class="row">
                            <div class="col-xs-offset 1 col-xs-11 col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6">
                                <div class="btn-toolbar" role="toolbar">
                                    <div class="btn-group btn-group-justified" role="group">
                                        <div class="btn-group" role="group">
                                            <button id="refresh" class="btn btn-primary" data-original-title="Refresh" @click="refreshDocuments()"><i class="fas fa-sync-alt" aria-hidden="true"></i></button>
                                            <b-tooltip target="refresh" triggers="hover">
                                                Refresh document list
                                            </b-tooltip>
                                        </div>
                                        <div class="btn-group" role="group">
                                            <button :disabled="!canUserUpload" id="upload" class="btn btn-primary" data-original-title="Upload" @click="OpenUploadDialogue()"><i class="fas fa-file-upload" aria-hidden="true"></i></button>
                                            <b-tooltip target="upload" triggers="hover">
                                                Upload a document
                                            </b-tooltip>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <slidy-thing id="uploadDocument" ref="uploadDocument" width="500px" openOn="right">
                <div class="container" :style="slidyThingContainerStyle">
                    <b-form-file v-model="fileToUpload"
                                 :state="Boolean(fileToUpload)"
                                 placeholder="Choose a file or drop it here..."
                                 drop-placeholder="Drop file here..."
                                 :disabled="inputsDisabled"></b-form-file>

                    <select class="form-control mt-2" :class="selectedDocumentType == null ? 'border-danger' : 'border-success'" v-model="selectedDocumentType" :disabled="inputsDisabled">
                        <option value="null">
                            SELECT Document Type...
                        </option>
                        <option v-for="(option, index) in attachmentDocumentTypes"
                                :key="'documentType_' + index"
                                :value="option.id">
                            {{option.label}}
                        </option>
                    </select>
                    <select v-if="selectedDocumentType == 1008" class="form-control mt-2" :class="selectedDocumentSubtype == null ? 'border-danger' : 'border-success'" v-model="selectedDocumentSubtype" :disabled="inputsDisabled">
                        <option value="null">
                            SELECT Document Subtype...
                        </option>
                        <option v-for="(option, index) in documentSubtypes"
                                :key="'documentSubtype_' + index"
                                :value="option.id">
                            {{option.label}}
                        </option>
                    </select>
                    <select v-if="selectedDocumentType == 1008" class="form-control mt-2" :class="selectedOption == null ? 'border-danger' : 'border-success'" v-model="selectedOption" :disabled="inputsDisabled">
                        <option value="null">
                            SELECT Option and gadget...
                        </option>
                        <option v-for="(option, index) in selectedWalkInRepairOptionGadget"
                                :key="'documentSubtype_' + index"
                                :value="option.id">
                            {{option.label}}
                        </option>
                    </select>
                    <div class="form-check mt-2">
                        <input class="form-check-input" type="checkbox" value="" id="visibleToCust" v-model="showCustomer" :disabled="inputsDisabled">
                        <label class="form-check-label" for="visibleToCust">
                            Document visible to customer in portal.
                        </label>
                    </div>
                    <transition name="fade">
                        <div v-if="alreadyUploadedPaymentReceiptForOption(selectedOption) && selectedDocumentType == 1008 && selectedDocumentSubtype == 1000" class="alert alert-danger mt-2" role="alert">
                            Delete the existing payment receipt
                        </div>
                    </transition>
                        <transition name="fade">
                            <div v-if="uploadSuccess == false" class="alert alert-danger mt-2" role="alert">
                                There was a problem uploading the file!
                            </div>
                            <div v-if="uploadSuccess == true" class="alert alert-success mt-2" role="alert">
                                Successfully uploaded file!
                            </div>
                        </transition>
                        <button type="button" class="btn btn-primary btn-lg btn-block mt-5" :disabled="isUploadButtonDisabled || (alreadyUploadedPaymentReceiptForOption(selectedOption) && selectedDocumentSubtype == 1000)" @click="handleDocumentUploadClick()">Upload</button>
                </div>
            </slidy-thing>
            <slidy-thing id="rejectDocument" ref="rejectDocument" width="500px" openOn="right">
                <div class="container" :style="slidyThingContainerStyle">
                    <select class="form-control mt-2" :class="selectedRejectReason == null ? 'border-danger' : 'border-success'" v-model="selectedRejectReason">
                        <option value="null">
                            SELECT Reason for rejection...
                        </option>
                        <option v-for="(option, index) in rejectReasons"
                                :key="'documentType_' + index"
                                :value="option.id">
                            {{option.label}}
                        </option>
                    </select>
                    <transition name="fade">
                        <div v-if="rejectSuccess == false" class="alert alert-danger mt-2" role="alert">
                            There was a problem!
                        </div>
                        <div v-if="rejectSuccess == true" class="alert alert-success mt-2" role="alert">
                            Success!
                        </div>
                    </transition>
                    <button type="button" class="btn btn-primary btn-lg btn-block mt-5" :disabled="selectedRejectReason == null || submitting" @click="handleDocumentRejectClick()">Reject</button>
                </div>
            </slidy-thing>
            <div v-if="selectedClaim && selectedClaim.documentDetails && selectedClaim.documentDetails.length > 0">
                <b-modal id="modal-document-status-history" title="Document Status">
                    <div v-if="documentStatusLoading">
                        <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div v-else>
                        <b-list-group v-if="this.selectedDocumentStatus && this.selectedDocumentStatus.length > 0">
                            <b-list-group-item v-for="(itm,idx) in selectedDocumentStatus" href="#" class="flex-column align-items-start+">
                                <div class="d-flex w-100 justify-content-between">
                                    <h5 class="mb-1">{{itm.documentStatus}}</h5>
                                    <small>{{itm.createdAgo}}</small>
                                </div>
                                <p class="mb-1" v-if="itm.documentRejectedReason">
                                    Reason: {{itm.documentRejectedReason}}
                                </p>
                                <p class="mb-1" v-if="itm.repairOptionType">
                                    Settlement option: {{itm.repairOptionType}} <small>({{itm.repairProvider}})</small>
                                </p>
                                <p class="mb-1" v-if="itm.reimbursementAmount">
                                    Reimbursement amount: {{itm.reimbursementAmount}} <small>(Repair price amount: {{itm.repairPriceValueCompared.gross}})</small>
                                </p>
                                <small>User: {{itm.createdByName ? itm.createdByName : 'SYSTEM'}}</small>
                            </b-list-group-item>
                        </b-list-group>
                        <div v-else>
                            <p>No status history to show.</p>
                        </div>
                    </div>
                </b-modal>
                <div v-for="(document, idx) in selectedClaim.documentDetails" :key="document.id" class="row mt-3 border-bottom ">
                    <div class="col-sm-6">
                        <p><strong>Document type:</strong> {{document.documentTypeLabel}}</p>
                        <p v-if="document.documentSubTypeLabel"><strong>Sub type:</strong> {{document.documentSubTypeLabel}}</p>
                        <p><strong>Date uploaded:</strong> {{document.dateCreated}}</p>
                        <p><strong>Original filename:</strong> {{document.originalFilename}}</p>
                        <p><strong>Visible to customer:</strong> {{TrueFalseYesNo(!document.internalOnly)}}</p>
                        <p v-if="document.documentSubTypeId == 1000"><strong>Repair cost total:</strong> {{formatCurrency(document.currencyCode,document.amount)}}</p>
                        <p><strong>Approval status:</strong> {{document.documentStatusLabel}} <a v-if="document.documentStatusLabel" @click="handleDocumentStatusMoreDetailsClick(document.id, document)" href="javascript:void(0)" class="document_approval_status_icon_link" :id="'doc_status_' + idx"><i class="fas fa-info-circle"></i></a></p>

                        <b-tooltip :target="'doc_status_' + idx" triggers="hover">
                            More details
                        </b-tooltip>

                        <p v-if="isRejected(document)"><strong>Rejected reason:</strong> {{document.rejectedReason}}</p>
                    </div>
                    <div class="col-sm-6">
                        <div class="mb-2">
                            <div class="row">
                                <div class="col-xs-offset 1 col-xs-11 col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6">
                                    <div class="btn-toolbar" role="toolbar">
                                        <div class="btn-group btn-group-justified" role="group">
                                            <div class="btn-group" role="group">
                                                <button :id="'approve_' + idx" class="btn btn-primary" data-original-title="Approve" @click="handleDocumentApproveClick(idx, document)" :disabled="isApproved(document) || !canUserApprove"><i class="fas fa-check" aria-hidden="true"></i></button>
                                                <b-tooltip :target="'approve_' + idx" triggers="hover">
                                                    Approve document
                                                </b-tooltip>
                                            </div>
                                            <div class="btn-group" role="group">
                                                <button :id="'reject_' + idx" class="btn btn-primary" data-original-title="Reject" @click="openRejectDialogue(document)" :disabled="isRejected(document) || !canUserReject"><i class="fas fa-times" aria-hidden="true"></i></button>
                                                <b-tooltip :target="'reject_' + idx" triggers="hover">
                                                    Reject document
                                                </b-tooltip>
                                            </div>

                                            <div class="btn-group" role="group">
                                                <button :id="'visibleToCust_' + idx" class="btn btn-primary" data-original-title="Visible" :disabled="!document.internalOnly || !canUserSetVisibility" @click="handleDocumentVisbleToCustClick(document,false)"><i class="fas fa-user-check" aria-hidden="true"></i></button>
                                                <b-tooltip :target="'visibleToCust_' + idx" triggers="hover">
                                                    Set document visible to customer
                                                </b-tooltip>
                                            </div>
                                            <div class="btn-group" role="group">
                                                <button :id="'notVisibleToCust_' + idx" class="btn btn-primary" data-original-title="NotVisible" :disabled="document.internalOnly || !canUserSetVisibility" @click="handleDocumentVisbleToCustClick(document,true)"><i class="fas fa-user-times" aria-hidden="true"></i></button>
                                                <b-tooltip :target="'notVisibleToCust_' + idx" triggers="hover">
                                                    Set document NOT visible to customer
                                                </b-tooltip>
                                            </div>

                                            <div class="btn-group" role="group">
                                                <button :id="'statusHistory_' + idx" class="btn btn-primary" data-original-title="NotVisible" @click="handleDocumentStatusMoreDetailsClick(document.id, document)"><i class="fas fa-bars" aria-hidden="true"></i></button>
                                                <b-tooltip :target="'statusHistory_' + idx" triggers="hover">
                                                    View document status history
                                                </b-tooltip>
                                            </div>

                                            <div class="btn-group" role="group">
                                                <button :id="'download_' + idx" class="btn btn-primary" data-original-title="Download" @click="handleDocumentLinkClick(document.id)"><i class="fas fa-download" aria-hidden="true"></i></button>
                                                <b-tooltip :target="'download_' + idx" triggers="hover">
                                                    Download document
                                                </b-tooltip>
                                            </div>
                                            <div class="btn-group" role="group">
                                                <button :disabled="!canUserDelete" :id="'delete_' + idx" class="btn btn-primary" data-original-title="Delete" @click="handleDocumentDeleteClick(idx, document)"><i class="fas fa-trash-alt" aria-hidden="true"></i></button>
                                                <b-tooltip :target="'delete_' + idx" triggers="hover">
                                                    Delete document
                                                </b-tooltip>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mb-2">
                            <a href="javascript:void(0);" @click="handleDocumentLinkClick(document.id)">
                                <img-with-key v-if="document.mimeType && document.mimeType.includes('image')"
                                              :imgsrc="documentUrl + document.id"
                                              :imgclass="'img-thumbnail'" />

                                <pdf-viewer-with-key v-else-if="document.mimeType && document.mimeType.includes('pdf')"
                                                     :viewerclass="'img-thumbnail'"
                                                     :viewerurl="documentUrl + document.id">
                                </pdf-viewer-with-key>

                                <div v-else class="border rounded" style="padding: 50px 50px 50px 50px; display: block;"><i class="far fa-eye-slash fa-10x"></i></div>
                            </a>
                        </div>
                    </div>
                </div>
                <b-pagination v-if="documentsTotalRecords > documents.pageSize"
                              class="mt-3"
                              align="center"
                              :total-rows="documentsTotalRecords"
                              :per-page="documents.pageSize"
                              :size="'sm'"
                              @input="handleDocumentsPaginationInput" />
            </div>
            <div v-else>
                <span>No documents have been uploaded...</span>
            </div>
        </b-tab>
        <b-tab title="Sales Uploads">
            <p><i class="fas fa-info-circle mr-2"></i>Clicking on the document preview will open / download the file.</p>
            <div v-if="salesDocumentUploads && salesDocumentUploads.length > 0">
                <div v-for="document in salesDocumentUploads" :key="document.id" class="row mt-3">
                    <div class="col-sm-6">
                        <p><strong>Date uploaded:</strong> {{document.createdDate}}</p>
                        <p><strong>Original filename:</strong> {{document.originalFileName}}</p>
                    </div>
                    <div class="col-sm-6">
                        <a href="javascript:void(0);" @click="handleSalesDocumentLinkClick2({ id: document.id, url: salesDocumentUrl })">
                            <img-with-key v-if="document.fileType && document.fileType.includes('image')"
                                          :imgsrc="salesDocumentUrl + document.id"
                                          :imgclass="'img-thumbnail'" />

                            <pdf-viewer-with-key v-else-if="document.fileType && document.fileType.includes('pdf')"
                                                 :viewerclass="'img-thumbnail'"
                                                 :viewerurl="salesDocumentUrl + document.id">
                            </pdf-viewer-with-key>

                            <div v-else class="border rounded" style="padding: 50px 50px 50px 50px; display: block;"><i class="far fa-eye-slash fa-10x"></i></div>
                        </a>
                    </div>
                </div>
            </div>
            <div v-else>
                <span>No documents have been uploaded...</span>
            </div>
        </b-tab>
        <b-tab title="Email Attachments">
            <p><i class="fas fa-info-circle mr-2"></i>Clicking on the document preview will open / download the file.</p>
            <div v-if="emailAttachments && emailAttachments.length > 0">
                <div v-for="(a, idx) in emailAttachments" :key="'attachment_' + idx" class="row mt-3">
                    <div class="col-sm-6">
                        <div class="form-inline mb-3">
                            <label><strong>Document type:</strong> </label>
                            <attachment-document-type class="ml-2"
                                                      :ref="'attachment-document-type_' + a.id"
                                                      :currentType="{ id: a.documentTypeId, label: a.documentTypeLabel }"
                                                      :documentId="a.id"
                                                      :documentTypes="attachmentDocumentTypes"
                                                      v-on:save-click="documentTypeSaveClick" />
                        </div>
                        <p><strong>Date uploaded:</strong> {{a.dateCreated}}</p>
                        <p><strong>Original filename:</strong> {{a.originalFilename}}</p>
                    </div>
                    <div class="col-sm-6">
                        <a href="javascript:void(0);" @click="handleDocumentLinkClick2({ id: a.id, url: attachmentUrl })">
                            <img-with-key v-if="a.contentType && a.contentType.includes('image')"
                                          :imgsrc="attachmentUrl + a.id"
                                          :imgclass="'img-thumbnail'" />

                            <pdf-viewer-with-key v-else-if="a.contentType && a.contentType.includes('pdf')"
                                                 :viewerclass="'img-thumbnail'"
                                                 :viewerurl="attachmentUrl + a.id">
                            </pdf-viewer-with-key>

                            <span v-else>Click to download</span>
                        </a>
                    </div>
                </div>
            </div>
            <div v-else>
                <span>No documents have been uploaded...</span>
            </div>
        </b-tab>
    </b-tabs>
</template>
<script>
    import { API_BASE_URL } from '../globalVar'
    import { mapActions, mapGetters } from 'vuex'
    import SimpleDisplayGrid from '@/components/SimpleDisplayGrid.vue'
    import DataListPagination from '@/components/DataListPagination.vue'
    import PdfViewer from '@/components/pdf-viewer/PdfViewer.vue'
    import imgWithKey from '@/components/imgWithKey.vue'
    import pdfViewerWithKey from '@/components/pdfViewerWithKey.vue'
    import { reportsApiService } from '@/services/reports-api.service.js'
    import AttachmentDocumentType from '@/components/Messages/AttachmentDocumentType.vue'

    import axios from 'axios'
    import SlidyThing from "@/components/SlidyThing.vue";

    import getSymbolFromCurrency from '@/util/currencySymbol.js'

    export default {
        name: 'claim-document-tabs',
        props: {
            claimId: {
                type: Number,
                required: true
            },
            load: Boolean
        },
        components: {
            SimpleDisplayGrid,
            DataListPagination,
            PdfViewer,
            'img-with-key': imgWithKey,
            'pdf-viewer-with-key': pdfViewerWithKey,
            'attachment-document-type': AttachmentDocumentType,
            "slidy-thing": SlidyThing
        },
        data: () => {
            return {
                documents: {
                    pageNumber: 1,
                    pageSize: 10
                },
                docDownloadKeys: [
                    {
                        documentId: null,
                        key1: null,
                        key2: null
                    }
                ],
                tabIndex: 0,
                fileToUpload: null,
                selectedDocumentType: null,
                selectedDocumentSubtype: null,
                submitting: false,
                uploadSuccess: null,
                showCustomer: false,

                rejectReasons: [],
                selectedRejectReason: null,
                rejectSuccess: null,
                selectedDocument: null,
                selectedDocumentStatus: null,
                documentStatusLoading: false,
                inputsDisabled: false,
                selectedOption: null
            }
        },
        computed: {
            ...mapGetters({
                emailAttachments: 'messageStore/selectedClaimAttachments',
                attachmentDocumentTypes: 'messageStore/documentTypes'
            }),
            selectedClaim() {
                return this.$store.getters.selectedClaim
            },
            documentUrl() {
                return `${API_BASE_URL}/api/admin/v1/document/download/`
            },
            attachmentUrl() {
                return `${API_BASE_URL}/api/admin/v1/message/download/`
            },
            salesDocumentUrl() {
                return `${API_BASE_URL}/api/admin/v1/document/sales/download/`
            },
            documentsTotalRecords() {
                if (this.selectedClaim && this.selectedClaim.documentDetails) {
                    return this.selectedClaim.documentDetails[0].totalRecords
                }
            },
            salesDocumentUploads() {
                return this.$store.getters.salesDocumentUploads
            },
            //emailAttachments() {
            //    return this.$store.messageStore.getters.selectedClaimAttachments
            //}
            slidyThingContainerStyle() {
                return {
                    "overflow-y": "auto",
                    "max-height": "100%",
                    "max-width": '500px',
                    "min-width": '500px'
                }
            },
            canUserApprove() {
                return !this.isReadonly;
            },
            canUserReject() {
                return !this.isReadonly;
            },
            canUserSetVisibility() {
                return !this.isReadonly;
            },
            canUserDelete() {
                return !this.isReadonly;
            },
            canUserUpload() {
                return !this.isReadonly;
            },
            isReadonly() {
                return this.$adminUser.isReadonly();
            },
            isUploadButtonDisabled() {
                return this.fileToUpload == null ||
                    this.selectedDocumentType == null ||
                    this.submitting ||
                    (this.selectedDocumentType == 1008 && this.selectedDocumentSubtype == null) ||
                    (this.selectedDocumentSubtype != null && this.selectedOption == null);
            },
            documentSubtypes() {
                return [{
                    id: 1000,
                    documentTypeId: 1008,
                    label: 'Payment Receipt'
                },
                {
                    id: 1001,
                    documentTypeId: 1008,
                    label: 'Work Authorisation / service confirmation'
                }]
            },
            selectedWalkInRepairOptionGadget() {
                try {
                    return this.selectedClaim
                        .selectedRepairOptionDetails
                        .filter(o => o.repairOptionTypeId = 1000 && o.dateCancelled == null)
                        .map(o => {
                            return {
                                id: o.id, label: `${o.repairOptionTypeLabel} ${o.makeLabel} ${o.modelLabel}`
                            }
})
                } catch {
                    return []
                }
            }
        },
        watch: {
            load: async function (newval, oldval) {
                if (newval == true) {
                    this.documents.pageNumber = 1
                    this.searchDocuments()
                }
            },
            tabIndex: async function (newVal, oldVal) {
                if (newVal == 0) {
                    this.documents.pageNumber = 1
                    this.searchDocuments()
                }
            },
            selectedDocumentType: async function (newVal, oldVal) {
                if (newVal != 1008) {
                    this.selectedDocumentSubtype = null
                    this.selectedOption = null
                }
            }
        },
        methods: {
            ...mapActions({
                loadRepairOptionsForClaim: 'fetchSelectedRepairOptionsClaim',
                fetchDocumentsClaim: 'fetchDocumentsClaim',
                fetchAttachmentsForClaim: 'messageStore/fetchAttachmentsForClaim',
                fetchAttachmentDocumentTypes: 'messageStore/fetchDocumentTypes',
                setDocumentTypeForAttachment: 'messageStore/setDocumentTypeForAttachment',
                raiseToastMsg: 'notificationModule/toast'
            }),
            handleDocumentsPaginationInput(payload) {
                if (payload) {
                    this.documents.pageNumber = payload
                    this.searchDocuments()
                }
            },
            searchDocuments() {
                let { claimId } = this //this.selectedClaim
                let { pageSize, pageNumber } = this.documents

                let ordering = null

                let pages = {
                    pageSize,
                    pageNumber
                }

                let criteria = {
                    claimId,
                    ...pages,
                    ...ordering
                }

                this.fetchDocumentsClaim(criteria)
            },
            getDocumentDownloadUrlWithKey(id, keyNum) {
                let doc = this.docDownloadKeys.find(d => d.documentId = id)
                if (doc) {
                    if (keyNum == 1) {
                        return doc.key1
                    }

                    if (keyNum == 2) {
                        return doc.key2
                    }
                }
                return 'null'
            },
            handleDocumentLinkClick(payload) {
                //console.log('-d: ', payload)
                reportsApiService.getDownloadKey()
                    .then(response => {
                        window.open(
                            this.documentUrl + payload + '/' + response.data,
                            '_blank'
                        )
                    })
            },
            handleDocumentLinkClick2(payload) {
                let { url, id } = payload
                reportsApiService.getDownloadKey()
                    .then(response => {
                        window.open(
                            url + id + '/' + response.data,
                            '_blank'
                        )
                    })
            },
            handleSalesDocumentLinkClick2(payload) {
                let { url, id } = payload
                reportsApiService.getDownloadKey()
                    .then(response => {
                        window.open(
                            url + id + '/' + response.data,
                            '_blank'
                        )
                    })
            },
            documentTypeSaveClick(payload) {
                //console.log(payload)
                //console.log(this.$refs['attachment-document-type_' + payload.documentId])

                this.$refs['attachment-document-type_' + payload.documentId][0].isWorking = true

                this.setDocumentTypeForAttachment({ attachmentId: payload.documentId, documentTypeId: payload.selected.id })
                    .then(() => {
                        let obj = this.$refs['attachment-document-type_' + payload.documentId][0]
                        obj.isWorking = false
                        obj.editMode = false
                    })
                    .catch(() => {
                        let obj = this.$refs['attachment-document-type_' + payload.documentId][0]
                        obj.isWorking = false
                        obj.editMode = false
                    })

                //setTimeout(() => {
                //    let obj = this.$refs['attachment-document-type_' + payload.documentId][0]
                //    obj.isWorking = false
                //    obj.editMode = false

                //    //this.$refs['attachment-document-type_' + payload.documentId][0].isWorking = false
                //}, 2000);


            },
            async handleDocumentDeleteClick(rowIndex, item) {

                const confirm = await this.$bvModal.msgBoxConfirm('Please confirm you want to Delete this document?')
                if (confirm != null) {
                    console.log('-c : ', confirm)
                    if (confirm == true) {
                        let { id, rv } = item
                        let payload = {
                            id,
                            rv
                        }
                        //console.log('-p : ', payload)

                        this.loading = true
                        try {
                            const response = await axios.post(`${API_BASE_URL}/api/admin/v1/document/delete/`, payload)
                            //console.log("-r : ", response)
                            const { data } = response
                            if (data) {
                                this.selectedClaim.documentDetails = this.selectedClaim.documentDetails.filter(i => i.id !== data.id)
                            }

                        } catch (error) {
                            console.error(error)
                        } finally { this.loading = false }
                    }
                }
            },
            async handleDocumentApproveClick(rowIndex, item) {
                //const confirm = await this.$bvModal.msgBoxConfirm('Please confirm you want to Delete this document?')
                //if (confirm != null) {
                //    console.log('-c : ', confirm)
                //    if (confirm == true) {
                        let { id, rv } = item
                        let payload = {
                            id,
                            rv
                        }
                        //console.log('-p : ', payload)

                        this.loading = true
                        try {
                            const response = await axios.post('/api/admin/v1/document/approve/', payload)
                            //console.log("-r : ", response)
                            const { data } = response
                            if (data) {
                                this.selectedClaim.documentDetails = this.selectedClaim.documentDetails.map(i => i.id !== data.id ? i : data)
                            }

                    } catch (error) {
                        console.error(error)
                    } finally { this.loading = false }
                //}
            },
            async handleDocumentRejectClick() {

                if (this.selectedDocument && this.selectedRejectReason) {
                    let { id, rv } = this.selectedDocument

                    let payload = {
                        id,
                        reasonId: this.selectedRejectReason,
                        rv
                    }
                    //console.log('-p : ', payload)

                    this.loading = true
                    try {
                        const response = await axios.post('/api/admin/v1/document/reject/', payload)
                        //console.log("-r : ", response)
                        const { data } = response
                        if (data) {
                            this.rejectSuccess = true
                            this.selectedClaim.documentDetails = this.selectedClaim.documentDetails.map(i => i.id !== data.id ? i : data)
                            setTimeout(() => {
                                this.$refs["rejectDocument"].hidePanel()
                                //this.submitting = false
                            }, 500);
                        }

                    } catch (error) {
                        this.rejectSuccess = false
                        console.error(error)
                    } finally { this.loading = false; this.selectedDocument = null; this.rejectSuccess = null }
                }
            },
            async handleDocumentVisbleToCustClick(item, internalOnly) {
                let { id, rv } = item
                let payload = {
                    id,
                    internalOnly,
                    rv
                }
                //console.log('-p : ', payload)

                this.loading = true
                try {
                    const response = await axios.post(`${API_BASE_URL}/api/admin/v1/document/internalOnly/`, payload)
                    //console.log("-r : ", response)
                    const { data } = response
                    if (data) {
                        this.rejectSuccess = true
                        this.selectedClaim.documentDetails = this.selectedClaim.documentDetails.map(i => i.id !== data.id ? i : data)
                    }

                } catch (error) {
                    console.error(error)
                } finally { this.loading = false; this.selectedDocument = null; }
            },
            async handleDocumentUploadClick() {
                let { claimId } = this.selectedClaim
                let { selectedDocumentType, selectedDocumentSubtype, selectedOption } = this

                let formData = new FormData()
                formData.append('claimId', claimId)
                formData.append('documentTypeId', selectedDocumentType)
                formData.append('documentSubtypeId', selectedDocumentSubtype)
                formData.append('selectedRepairOptionId', selectedOption)
                formData.append('files[0]', this.fileToUpload)
                formData.append('showToCustomer', this.showCustomer)

                this.loading = true
                this.submitting = true
                try {
                    const response = await axios.post(`${API_BASE_URL}/api/admin/v1/document/upload/`,
                        formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    //console.log("-r : ", response)
                    const { data } = response
                    if (data) {
                        this.uploadSuccess = true
                        this.inputsDisabled = true
                        setTimeout(() => {
                            this.refreshDocuments()
                            this.$refs["uploadDocument"].hidePanel()
                            this.submitting = false
                            this.inputsDisabled = false
                        }, 3000);
                    } else {
                        this.uploadSuccess = false
                        this.submitting = flase
                    }

                } catch (error) {
                    console.error(error)
                    this.uploadSuccess = false
                    this.submitting = false
                } finally {
                    this.loading = false
                    this.fileToUpload = null
                    this.selectedDocumentType = null
                    this.selectedDocumentSubtype = null
                    this.selectedOption = null
                }
                //    }
                //}
            },
            isApproved(item) {
                if (item) {
                    if (item.documentStatusId != null) {
                        var approvedStatuses = [1001, 1002, 1003]
                        return approvedStatuses.includes(item.documentStatusId)
                    }
                }
            },
            isRejected(item) {
                if (item) {
                    if (item.documentStatusId != null) {
                        var rejectedStatuses = [1004]
                        return rejectedStatuses.includes(item.documentStatusId)
                    }
                }
            },
            async fetchDocumentRejectedReasons() {
                try {
                    const response = await axios.get(`${API_BASE_URL}/api/admin/v1/document/rejectedReasons/`)
                    const { data } = response
                    if (data) {
                        this.rejectReasons = data
                    }

                } catch (error) {
                    console.error(error)
                } finally { }
            },
            getApprovalStatus(item) {
                if (item) {
                    if (item.approved != null) {
                        if (item.approved == true) {
                            return 'APPROVED'
                        }
                    }
                    if (item.rejected != null) {
                        if (item.rejected == true) {
                            return 'REJECTED'
                        }
                    }
                }
            },
            refreshDocuments() {
                this.documents.pageNumber = 1
                this.searchDocuments()
            },
            OpenUploadDialogue() {
                console.log('-ro: ', this.selectedClaim.selectedRepairOptionDetails.filter(o => o.repairOptionTypeId = 1000 && o.dateCancelled == null))
                this.fileToUpload = null
                this.selectedDocumentType = null
                this.uploadSuccess = null
                if (this.$refs["uploadDocument"])
                    this.$refs["uploadDocument"].showPanel();
            },
            openRejectDialogue(doc) {
                this.selectedDocument = doc
                if (this.$refs["rejectDocument"])
                    this.$refs["rejectDocument"].showPanel();
            },
            TrueFalseYesNo(val) {
                return val ? 'YES' : 'NO';
            },
            formatCurrency(currencyCode, amount) {
                if (typeof currencyCode !== 'string') return undefined
                if (typeof amount !== 'number') return undefined
                return getSymbolFromCurrency(currencyCode) + amount.toFixed(2)
            },
            async handleDocumentStatusMoreDetailsClick(documentId, document) {
                this.selectedDocument = document
                //console.log(documentId)
                this.fetchStatusHistoryForDocument(documentId)

                this.$bvModal.show('modal-document-status-history')
            },
            async fetchStatusHistoryForDocument(documentId) {
                try {
                    this.documentStatusLoading = true
                    const response = await axios.get(`${API_BASE_URL}/api/admin/v1/document/documentStatusHistory/${documentId}`)
                    const { data } = response
                    if (data) {
                        console.log('-d : ', data)
                        this.selectedDocumentStatus = data
                    }

                } catch (error) {
                    console.error(error)
                } finally { this.documentStatusLoading = false }
            },
            alreadyUploadedPaymentReceiptForOption(optionId) {
                if (this.selectedClaim && this.selectedClaim.documentDetails) {
                    return this.selectedClaim.documentDetails.findIndex(d => d.documentSubTypeId == 1000 && d.selectedRROptionId == optionId) > -1
                } else {
                    return false
                }

            }
        },
        async mounted() {
            this.fetchAttachmentDocumentTypes()
            await this.fetchDocumentRejectedReasons()


            let { claimId } = this.selectedClaim

            let ordering = null

            let pages = {
                pageSize: 100,
                pageNumber: 1
            }

            let criteria = {
                claimId,
                ...pages,
                ...ordering
            }
            this.loadRepairOptionsForClaim(criteria)

            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                if (modalId == 'modal-document-status-history') {
                    this.selectedDocument = null
                    this.selectedDocumentStatus = null
                }
            })

            console.log('-pl: ', this.$adminUser.getPaymentApprovalLimit())
        }
    }
</script>
<style>
    a.document_approval_status_icon_link {
        color: inherit !important;
        text-decoration: !important;
    }
</style>